import { render, staticRenderFns } from "./BackLogoNextIcon.vue?vue&type=template&id=0ed16070&"
import script from "./BackLogoNextIcon.vue?vue&type=script&lang=js&"
export * from "./BackLogoNextIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports